import type { ElevationProvenance } from '@features/elevationChart/model/actions.js';
import type { ElevationDecision } from './reducer.js';

/**
 * What the chart may credit a loaded track's elevation to. Only an override
 * replaces every value with our terrain model's; a track kept as recorded — or
 * one where the server merely filled the gaps — draws measurements no terrain
 * model answered for, so it names no source at all.
 */
export function elevationProvenance(
  decision: ElevationDecision,
): ElevationProvenance {
  return decision === 'all' ? 'terrain-model' : 'recorded';
}
